import { forwardRef } from 'react';

import { useForkRef } from '@spazious/react-hooks';

import { Flex, FlexElement, FlexProps } from '../Flex/Flex.js';

import { StickyHookOptions, useSticky } from './useSticky.js';

export interface StickyProps extends FlexProps, StickyHookOptions {
  children?: React.ReactNode;
}

export const Sticky = forwardRef<FlexElement, StickyProps>(({ children, ...restProps }, ref) => {
  const [setStickyElem, { top, left }] = useSticky<FlexElement>(restProps);

  const forkedRef = useForkRef(setStickyElem, ref);

  return (
    <Flex
      ref={forkedRef}
      {...restProps}
      style={{
        transform: `translate(${left}px, ${top}px)`,
      }}
    >
      {children}
    </Flex>
  );
});
